module.exports = __webpack_public_path__ + "static/skihire--map-aa2fc58c3a13a87eb16ff4a6fb088a96.png";